/* global atlas */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from '../../LoadingIndicator';
const { REACT_APP_AZURE_MAP_KEY } = process.env;

export class SinglePointMap extends Component {
  _isMounted = false;
  static propTypes = {
    mapId: PropTypes.string.isRequired,
    lat: PropTypes.number.isRequired,
    long: PropTypes.number.isRequired,
    containerClass: PropTypes.string.isRequired,
    zoomLevel: PropTypes.number
  };
  state = {
    mapLoaded: false
  };
  async componentDidMount() {
    this._isMounted = true;
    await this.loadMap();
  }
  async loadMap() {
    if (!this._isMounted) {
      return;
    }
    const { mapId, lat, long, zoomLevel } = this.props;
    const { mapLoaded } = this.state;
    const mapZoom = zoomLevel || 15;

    const mapCoordinates = [long, lat];
    atlas.setSubscriptionKey(REACT_APP_AZURE_MAP_KEY);
    //const component = this;
    if (!mapLoaded) {
      const map = new atlas.Map(mapId, {
        center: mapCoordinates,
        zoom: mapZoom,
        //Add your Azure Maps subscription key to the map SDK. Get an Azure Maps key at https://azure.com/maps
        authOptions: {
          authType: 'subscriptionKey',
          subscriptionKey: REACT_APP_AZURE_MAP_KEY
        },
        style: 'satellite'
      });
      //Wait until the map resources are ready.
      map.events.add('ready', function() {
        /* Construct a zoom control*/
        const zoomControl = new atlas.control.ZoomControl();

        /* Add the zoom control to the map*/
        map.controls.add(zoomControl, {
          position: 'top-right'
        });
        //These are the map view controls
        map.controls.add(
          new atlas.control.StyleControl({
            style: 'dark',
            //Optionally specify which map styles you want to appear in the picker.
            //All styles available with the S0 license tier appear by default in the control.
            //If using a S1 tier license, you can use the mapStyles option to add the 'satellite' and 'satellite_road_labels' styles to the control.
            mapStyles: [
              'road',
              'grayscale_dark',
              'night',
              'road_shaded_relief',
              'satellite',
              'satellite_road_labels'
            ]
          }),
          {
            position: 'bottom-right'
          }
        );

        map.markers.add(
          new atlas.HtmlMarker({
            color: 'DodgerBlue',
            position: mapCoordinates
          })
        );
      });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const { mapId, containerClass } = this.props;
    const { mapLoaded } = this.state;
    return (
      <div
        ref={() => {
          //  this.loadMap();
        }}
      >
        <div
          id={mapId}
          className={containerClass}
          style={{ position: 'relative' }}
        >
          {!mapLoaded && <LoadingIndicator />}
        </div>
      </div>
    );
  }
}

export default SinglePointMap;
